import { network } from '@root/utils'
import { handleReturn, MutationFunction, QueryFunction } from '../root'

interface IVerohallintoCertificateStatusResponse {
  is_fetching: boolean
  has_certificate: boolean
  has_encountered_error_in_fetching: boolean
}

interface IVerohallintoCertificateStatusRequest {
  slug: string
}

export const fetchVerohallintoCertificateStatus: QueryFunction<
  IVerohallintoCertificateStatusRequest,
  IVerohallintoCertificateStatusResponse
> = async ({ slug }) => {
  const url = `/v1/integrations/business/${slug}/verohallinto/certificate/status/`
  const { data } = await network.httpClient.request({
    url,
    method: 'GET'
  })
  return data
}

interface IAddVerohallintoCertificateProps {
  slug: string
}

export interface IVerohallintoCertificateTransmissionValues {
  transmission_id: string
  transmission_password: string
}

export const addVerohallintoCertificate: MutationFunction<
  IAddVerohallintoCertificateProps,
  IVerohallintoCertificateTransmissionValues
> = async ({ slug }, data) => {
  const url = `/v1/integrations/business/${slug}/verohallinto/certificate/add/`
  const { status } = await network.httpClient.request({
    url,
    method: 'POST',
    data: {
      transmission_id: data.transmission_id,
      transmission_password: data.transmission_password
    },
    validateStatus: () => true
  })
  return handleReturn({ status })
}
